import React, { useEffect, useState } from "react";
import styles from "./school-statistics-overview.module.css";
import StatisticsCard from "../../../../../components/statistics-card/statistics-card";
import { fetchSchoolStatistics } from "../../../../../services/school_info";
import { toast } from "react-toastify";

const overview_statistics = [
  {
    icon_name: "book-closed",
    icon_fill: "transparent",
    icon_stroke: "#ffffff",
    icon_width: "24px",
    icon_height: "24px",
    heading_text: "Academic Year",
    card_bg_color: "rgba(242, 255, 244, 1)",
    icon_container_bg_color: "rgba(41, 194, 65, 1)",
    statistic_value: "academic_year",
  },
  {
    icon_name: "clipboard",
    icon_fill: "transparent",
    icon_stroke: "#ffffff",
    icon_width: "24px",
    icon_height: "24px",
    heading_text: "Active Term",
    card_bg_color: "rgba(231, 248, 255, 1)",
    icon_container_bg_color: "rgba(75, 202, 255, 1)",
    statistic_value: "term_name",
  },
  {
    icon_name: "users-icon",
    icon_fill: "transparent",
    icon_stroke: "#ffffff",
    icon_width: "24px",
    icon_height: "24px",
    heading_text: "No of Level/Grades",
    card_bg_color: "rgba(255, 251, 233, 1)",
    icon_container_bg_color: "rgba(235, 206, 61, 1)",
    statistic_value: "levels_count",
  },
  {
    icon_name: "book-closed",
    icon_fill: "transparent",
    icon_stroke: "#ffffff",
    icon_width: "24px",
    icon_height: "24px",
    heading_text: "No of Classes",
    card_bg_color: "rgba(233, 243, 255, 1)",
    icon_container_bg_color: "rgba(86, 155, 246, 1)",
    statistic_value: "classroom_count",
  },
  {
    icon_name: "clipboard",
    icon_fill: "transparent",
    icon_stroke: "#ffffff",
    icon_width: "24px",
    icon_height: "24px",
    heading_text: "No of Departments",
    card_bg_color: "rgba(245, 240, 255, 1)",
    icon_container_bg_color: "rgba(127, 86, 217, 1)",
    statistic_value: "department_count",
  },
  {
    icon_name: "users-icon",
    icon_fill: "transparent",
    icon_stroke: "#ffffff",
    icon_width: "24px",
    icon_height: "24px",
    heading_text: "No of Subjects",
    card_bg_color: "#FFEBFE",
    icon_container_bg_color: "#F442EB",
    statistic_value: "subject_count",
  },
];

const SchoolStatisticsOverview = () => {
  const [schoolInfo, setSchoolInfo] = useState({});

  useEffect(() => {
    getSchoolStatistics();
    const handler = () => getSchoolStatistics();
    window.addEventListener("refetch-school", handler);
    return () => {
      window.removeEventListener("refetch-school", handler);
    };
  }, []);

  const getSchoolStatistics = async () => {
    try {
      const response = await fetchSchoolStatistics();
      if (response?.data) {
        const data = response?.data?.data;
        setSchoolInfo(data);
      }
    } catch (err) {
      if (err?.data?.message) {
        toast.error(err?.data?.message);
      }
      console.log(err);
    }
  };

  return (
    <div className={styles.statistics_overview}>
      <div className={styles.statistics}>
        {overview_statistics?.map(
          ({
            icon_name,
            icon_fill,
            icon_stroke,
            icon_width,
            icon_height,
            heading_text,
            card_bg_color,
            icon_container_bg_color,
            statistic_value,
          }) => (
            <div className={styles.statistics_card}>
              <StatisticsCard
                icon_name={icon_name}
                icon_fill={icon_fill}
                icon_stroke={icon_stroke}
                icon_width={icon_width}
                icon_height={icon_height}
                heading_text={heading_text}
                card_bg_color={card_bg_color}
                icon_container_bg_color={icon_container_bg_color}
                statistic_value={schoolInfo?.[statistic_value] ?? "-"}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SchoolStatisticsOverview;
